import { Component } from '@angular/core';

@Component({
    selector: 'app-no-nav-header',
    templateUrl: './no-nav-header.component.html',
})
export class NoNavHeaderComponent {
    constructor() {}
}
